'use client'
// Statut usager (OS Actif · Bonjour · présence · Niveau/XP) déplacé dans la Topbar.
import type { OnlineInfo, UserProfile } from '@/types/landing'
import { RadarHero } from './RadarHero'
import { LastCityCard, useLastCity } from './LastCityCard'

// Pilule de lien (même style que « Votre Profil → »)
function LinkPill({ label, href }: { label: string; href: string }) {
  return (
    <a
      href={href}
      style={{
        display: 'inline-block',
        fontSize: 10, fontFamily: 'var(--font-mono)',
        color: 'var(--text-muted)', textDecoration: 'none', letterSpacing: '0.06em',
        padding: '10px 20px', border: '1px solid rgba(255,255,255,0.08)',
        borderRadius: 8, transition: 'color 0.15s, border-color 0.15s',
        whiteSpace: 'nowrap',
      }}
      onMouseEnter={e => { const el = e.currentTarget; el.style.color = '#fff'; el.style.borderColor = 'var(--accent)' }}
      onMouseLeave={e => { const el = e.currentTarget; el.style.color = 'var(--text-muted)'; el.style.borderColor = 'rgba(255,255,255,0.08)' }}
    >
      {label}
    </a>
  )
}

export function HeroBanner({}: {
  firstName?:  string | null
  onlineInfo?: OnlineInfo
  profile?:    UserProfile | null
}) {
  const lastCity = useLastCity()
  return (
    <div className="hud-card" style={{
      padding: 'clamp(20px, 3.5vw, 36px)',
      marginBottom: '24px',
      position: 'relative', overflow: 'hidden',
      animation: 'fadeUp 0.5s var(--ease-out)',
    }}>
      {/* Halos décoratifs */}
      <div style={{
        position: 'absolute', top: '-60%', right: '8%', width: 380, height: 380,
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(79,124,255,0.10) 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />
      <div style={{
        position: 'absolute', bottom: '-40%', left: '20%', width: 240, height: 240,
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(0,212,255,0.06) 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />

      {/* Titre principal — au-dessus */}
          <h1 className="hud-gradient-text font-display" style={{
            fontSize: 'clamp(28px, 5vw, 50px)', fontWeight: 800,
            lineHeight: 1.0, letterSpacing: '-0.03em', marginBottom: 16,
          }}>
            Votre environnement de travail intelligent
          </h1>

      {/* Layout principal : contenu gauche + logo droit */}
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 'clamp(20px, 4vw, 48px)' }}>

        {/* ─── Colonne gauche ─── */}
        <div style={{ flex: 1, minWidth: 0 }}>

          {/* Radar mondial (gauche) + dernière ville analysée (droite) */}
          <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap', alignItems: 'stretch' }}>
            <div style={{ flex: '1 1 420px', minWidth: 300, maxWidth: 720 }}>
              <RadarHero />
            </div>
            <div style={{ flex: '1 1 280px', minWidth: 260, maxWidth: 420 }}>
              <LastCityCard data={lastCity} />
            </div>
          </div>

          

          {/* Ligne accent */}
          <div style={{
            height: 1, width: 'min(360px, 90%)',
            background: 'linear-gradient(90deg, var(--accent), var(--accent-cyan), transparent)',
            marginBottom: 14, opacity: 0.45,
          }} />

          {/* Liens : profil + fiche de la dernière ville analysée */}
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
            <LinkPill label="Votre Profil →" href="/profil" />
            {lastCity.city && <>
              <LinkPill label="📜 Histoire & Patrimoine" href={`${lastCity.ficheHref}&section=histoire`} />
              <LinkPill label="🎯 Attraits & activités"  href={`${lastCity.ficheHref}&section=attraits`} />
              <LinkPill label="🗺 Carte interactive de la ville" href={lastCity.ficheHref} />
            </>}
          </div>
          
        </div>
     
      </div>
    </div>
  )
}
